module.exports = __webpack_public_path__ + "img/professor_hindsight.877cdbc0.png";